import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandDV(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z"
        fill="#ED1B24"
      />
      <path
        d="M10.868 9.6h4.917v.82h-.78v.052l1.68 1.999h.12l1.678-1.897v-.154h-.72V9.6H21.6v.82h-.899l-3.358 3.948h-2.278l-3.297-3.948h-.56c.398.283.665.651.665 1.11v.46c0 .8-1.325 2.41-3.837 2.41H2.4v-.82h.78v-3.076H2.4v-.82h6.236c.642 0 1.544.17 2.232.53V9.6Zm-5.17.955v2.973h1.799c.785 0 1.738-.625 1.738-1.486 0-.58-.66-1.487-1.798-1.487h-1.74Z"
        fill="#fff"
      />
    </BaseIcon>
  );
}
